import { checkPropTypes } from 'prop-types'
import React from 'react'

export default function KeyIcon({ styles, width, height }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.934 16.0384H16.833L16.801 15.8784C16.503 14.4234 15.704 13.1044 14.553 12.1654C13.403 11.2264 11.952 10.7074 10.466 10.7054C6.901 10.7054 4 13.6064 4 17.1714C4 20.7364 6.901 23.6384 10.466 23.6384C11.951 23.6364 13.403 23.1174 14.553 22.1784C15.704 21.2384 16.502 19.9194 16.801 18.4644L16.833 18.3054H20V20.9724H22.268V18.3054H25.333V22.3054H27.6V18.3054H28.934V16.0384ZM10.467 21.3714C8.151 21.3714 6.267 19.4874 6.267 17.1724C6.267 14.8564 8.151 12.9724 10.467 12.9724C12.782 12.9724 14.667 14.8564 14.667 17.1724C14.667 19.4874 12.782 21.3714 10.467 21.3714Z"
        fill="#565656"
      />
    </svg>
  )
}

KeyIcon.propTypes = {
  styles: checkPropTypes.any,
  width: checkPropTypes.string,
  height: checkPropTypes.string,
}
